import {
	AppHomeContainer,
	WalletContainer,
	CustomerContainer,
	InvoiceContainer,
	PayBillsContainer,
	SettingsContainer,
	EmployeesContainer,
	BusinessAdminContainer,
	PayrollContainer,
	SubwalletContainer,
	CommissionContainer,
	InventoryContainer,
	OrderPageContainer,
	EmployeeSalesReportContainer,
	BulkSmsContainer,
	PaymentLinkContainer,
	SplitPaymentsContainer,
	BookingContainer,
	VendorContainer,
	OrdersContainer,
	TransactionsNewContainer,
	ApiKeysContainer,
} from '../containers';
import { PlansBilling, SubscriptionExpired } from '../pages';

import constant from '../utils/constant';

const protectedRoutes = [
	{
		path: constant.Routes.AppHome,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <AppHomeContainer />,
	},
	{
		path: constant.Routes.Wallet,
		module: 'WALLET',
		type: 'GENERAL',
		element: <WalletContainer />,
	},
	{
		path: constant.Routes.Customer,
		module: 'CUSTOMER',
		element: <CustomerContainer />,
	},
	{
		path: constant.Routes.Invoice,
		module: 'INVOICE/RECEIPT',
		element: <InvoiceContainer />,
	},
	{
		path: constant.Routes.PayBills,
		module: 'BILL PAYMENT',
		type: 'GENERAL',
		element: <PayBillsContainer />,
	},
	{
		path: constant.Routes.Transactions,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <TransactionsNewContainer />,
	},
	{
		path: constant.Routes.Settings,
		element: <SettingsContainer />,
	},
	{
		path: constant.Routes.Employees,
		module: 'PAYROLL',
		element: <EmployeesContainer />,
	},
	{
		path: constant.Routes.SalesAgentReport,
		module: 'PAYROLL',
		element: <EmployeeSalesReportContainer />,
	},
	{
		path: constant.Routes.Payroll,
		module: 'PAYROLL',
		element: <PayrollContainer />,
	},
	{
		path: constant.Routes.BusinessAdmin,
		module: 'BUSINESS ADMIN',
		element: <BusinessAdminContainer />,
	},
	{
		path: constant.Routes.Subwallet,
		module: 'PETTY CASH',
		type: 'GENERAL',
		element: <SubwalletContainer />,
	},
	{
		path: constant.Routes.Commissions,
		module: 'PAYROLL',
		element: <CommissionContainer />,
	},
	{
		path: constant.Routes.Inventory,
		module: 'INVENTORY',
		element: <InventoryContainer />,
	},
	{
		path: constant.Routes.OrderPage,
		module: 'PAYROLL',
		element: <OrderPageContainer />,
	},
	{
		path: constant.Routes.BulkSms,
		module: 'CUSTOMER',
		element: <BulkSmsContainer />,
	},
	{
		path: constant.Routes.Vendor,
		module: 'VENDOR',
		element: <VendorContainer />,
	},
	{
		path: constant.Routes.PaymentLink,
		element: <PaymentLinkContainer />,
	},
	{
		path: constant.Routes.Booking,
		element: <BookingContainer />,
	},
	{
		path: constant.Routes.SplitPayments,
		module: 'INVENTORY',
		element: <SplitPaymentsContainer />,
	},
	{
		path: constant.Routes.SubExpired,
		element: <SubscriptionExpired />,
	},
	{
		path: constant.Routes.Orders,
		// module: 'ORDERS',
		element: <OrdersContainer />,
	},
	{
		path: constant.Routes.TransactionsNew,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <TransactionsNewContainer />,
	},
	{
		path: constant.Routes.ApiKeys,
		// module: 'TRANSACTION',
		type: 'GENERAL',
		element: <ApiKeysContainer />,
	},
	{
		path: constant.Routes.Billing,
		module: 'TRANSACTION',
		type: 'GENERAL',
		element: <PlansBilling />,
	},
	// {
	// 	path: constant.Routes.Catalogue,
	// 	// module: 'TRANSACTION',
	// 	type: 'GENERAL',
	// 	element: <CatalogueContainer />,
	// },
	// {
	// 	path: constant.Routes.ViewMoreDesign,
	// 	// module: 'TRANSACTION',
	// 	type: 'GENERAL',
	// 	element: <ViewMoreDesign />,
	// },
];

export default protectedRoutes;
